import axios from 'axios';
import apiConfig from '../api.config';

export default function sendRequestFuncionalityEmail({ hotelId, functionality }) {
  const {
    host,
    URIs: { sendRequestFuncionalityEmail },
  } = apiConfig;

  const uri = `${host}${sendRequestFuncionalityEmail.replace(':hotelId', hotelId)}`;

  return axios
    .post(uri, JSON.stringify({ feature: functionality }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
